import { useMemo } from 'react'
import { useInitAppt } from './useInitAppt'
import { useServiceDuration } from './useServiceDuration'
import { useSchedulingWizard } from '../../wizardContext'
import { filtersInitValues, type FiltersFormModel } from '../formConfig'

export function useData() {
  useInitAppt()

  const [{ stack, bestFitInput, branchId, appointmentTechId }] =
    useSchedulingWizard()

  const serviceDuration = useServiceDuration(branchId, bestFitInput.serviceIds)

  const initialValues = useMemo<FiltersFormModel>(
    () => ({
      ...filtersInitValues,
      duration: !!serviceDuration ? serviceDuration : 30,
      techId: appointmentTechId ?? filtersInitValues.techId,
    }),
    [appointmentTechId, serviceDuration],
  )

  const isRescheduling = useMemo(() => !stack.includes('locAndSvcs'), [stack])

  return {
    isRescheduling,
    initialValues,
  }
}
